var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('datatable',{attrs:{"fields":_vm.fields,"entityService":_vm.listRangeService,"options":_vm.options}})}
var staticRenderFns = []

export { render, staticRenderFns }